(function() {
  "use strict";

  var renewalRoots = [];
  var turnstileReady = false;
  var turnstileScriptLoading = false;
  var TURNSTILE_TOKEN_MAX_AGE = 240000;

  window.ffRenewalTurnstileReady = function() {
    turnstileReady = true;
    turnstileScriptLoading = false;
    renewalRoots.forEach(renderTurnstileWidget);
  };

  function formatOrderDate(value) {
    var date;
    var day;
    var suffix = "th";

    if (!value) {
      return "";
    }

    try {
      date = new Date(value);
      day = date.getDate();

      if (day % 100 < 11 || day % 100 > 13) {
        if (day % 10 === 1) {
          suffix = "st";
        } else if (day % 10 === 2) {
          suffix = "nd";
        } else if (day % 10 === 3) {
          suffix = "rd";
        }
      }

      return day + suffix + " " + new Intl.DateTimeFormat("en-GB", {
        month: "long",
        year: "numeric"
      }).format(date);
    } catch (error) {
      return value;
    }
  }

  function formatMoney(amount, currencyCode) {
    var numeric = Number(amount);

    if (!isFinite(numeric)) {
      return "";
    }

    try {
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: currencyCode || "GBP"
      }).format(numeric);
    } catch (error) {
      return numeric.toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function toNumericVariantId(rawId) {
    if (!rawId) {
      return "";
    }

    var value = String(rawId);

    if (value.indexOf("gid://") === 0) {
      var parts = value.split("/");
      return parts[parts.length - 1] || "";
    }

    return value;
  }

  function createStatus(message, type) {
    return {
      message: message || "",
      type: type || ""
    };
  }

  function getButtonDefaultLabel(button, fallback) {
    if (!button) {
      return fallback || "";
    }

    return button.getAttribute("data-default-label") || fallback || "";
  }

  function setButtonLabel(button, label) {
    var labelNode;

    if (!button) {
      return;
    }

    labelNode = button.querySelector("[data-button-label]");

    if (labelNode) {
      labelNode.textContent = label;
      return;
    }

    button.textContent = label;
  }

  function normalizePostcodeInput(value) {
    return String(value == null ? "" : value)
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "");
  }

  function formatPostcodeInput(value) {
    var normalized = normalizePostcodeInput(value);

    if (normalized.length <= 3) {
      return normalized;
    }

    return normalized.slice(0, -3) + " " + normalized.slice(-3);
  }

  function looksLikeEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
  }

  function isTurnstileTokenFresh(state) {
    return Boolean(
      state.cachedToken
        && state.cachedTokenCreatedAt
        && Date.now() - state.cachedTokenCreatedAt < TURNSTILE_TOKEN_MAX_AGE
    );
  }

  function clearCachedTurnstileToken(state) {
    state.cachedToken = "";
    state.cachedTokenCreatedAt = 0;
  }

  function getTurnstileState(root) {
    if (!root._ffRenewalTurnstile) {
      root._ffRenewalTurnstile = {
        widgetId: null,
        pendingResolve: null,
        pendingReject: null,
        cachedToken: "",
        cachedTokenCreatedAt: 0,
        tokenPromise: null,
        prewarmTimerId: null
      };
    }

    return root._ffRenewalTurnstile;
  }

  function ensureTurnstileScript() {
    if (window.turnstile) {
      turnstileReady = true;
      return;
    }

    if (turnstileReady || turnstileScriptLoading) {
      return;
    }

    if (document.querySelector('script[src*="challenges.cloudflare.com/turnstile/v0/api.js"]')) {
      turnstileScriptLoading = true;
      return;
    }

    turnstileScriptLoading = true;

    var script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=ffRenewalTurnstileReady";
    script.async = true;
    script.defer = true;
    script.onerror = function() {
      turnstileScriptLoading = false;
    };
    document.head.appendChild(script);
  }

  function clearPendingTurnstile(state) {
    state.pendingResolve = null;
    state.pendingReject = null;
  }

  function rejectPendingTurnstile(state, message) {
    if (!state.pendingReject) {
      return;
    }

    var reject = state.pendingReject;
    clearPendingTurnstile(state);
    reject(new Error(message));
  }

  function renderTurnstileWidget(root) {
    var siteKey = root.dataset.turnstileSitekey || "";
    var container = root.querySelector("[data-turnstile-container]");
    var state = getTurnstileState(root);

    if (!siteKey || !container || state.widgetId !== null || !window.turnstile) {
      return;
    }

    state.widgetId = window.turnstile.render(container, {
      sitekey: siteKey,
      size: "invisible",
      execution: "execute",
      "refresh-expired": "auto",
      callback: function(token) {
        if (!state.pendingResolve) {
          return;
        }

        var resolve = state.pendingResolve;
        clearPendingTurnstile(state);
        resolve(token);
      },
      "error-callback": function() {
        rejectPendingTurnstile(state, "Security check failed. Please refresh the page and try again.");
      },
      "expired-callback": function() {
        rejectPendingTurnstile(state, "Security check expired. Please try again.");
      },
      "timeout-callback": function() {
        rejectPendingTurnstile(state, "Security check timed out. Please try again.");
      }
    });
  }

  function resetTurnstile(root) {
    var state = getTurnstileState(root);

    clearPendingTurnstile(state);
    clearCachedTurnstileToken(state);
    state.tokenPromise = null;

    if (!window.turnstile || state.widgetId === null) {
      return;
    }

    window.turnstile.reset(state.widgetId);
  }

  function getTurnstileToken(root) {
    var siteKey = root.dataset.turnstileSitekey || "";
    var state = getTurnstileState(root);

    if (!siteKey) {
      return Promise.resolve("");
    }

    if (isTurnstileTokenFresh(state)) {
      return Promise.resolve(state.cachedToken);
    }

    if (state.tokenPromise) {
      return state.tokenPromise;
    }

    ensureTurnstileScript();

    state.tokenPromise = new Promise(function(resolve, reject) {
      var interval = 100;
      var elapsed = 0;
      var maxWait = 10000;
      var executionTimeoutId = null;

      function settle(callback, value) {
        if (executionTimeoutId) {
          window.clearTimeout(executionTimeoutId);
          executionTimeoutId = null;
        }

        callback(value);
      }

      function tryExecute() {
        var state = getTurnstileState(root);

        renderTurnstileWidget(root);

        if (window.turnstile && state.widgetId !== null) {
          state.pendingResolve = function(token) {
            settle(resolve, token);
          };
          state.pendingReject = function(error) {
            settle(reject, error);
          };
          executionTimeoutId = window.setTimeout(function() {
            rejectPendingTurnstile(state, "Security check timed out. Please try again.");
          }, 12000);
          window.turnstile.execute(state.widgetId);
          return;
        }

        elapsed += interval;

        if (elapsed >= maxWait) {
          reject(new Error("Security check timed out. Please refresh the page and try again."));
          return;
        }

        setTimeout(tryExecute, interval);
      }

      tryExecute();
    }).then(function(token) {
      state.cachedToken = token || "";
      state.cachedTokenCreatedAt = token ? Date.now() : 0;
      state.tokenPromise = null;
      return token;
    }).catch(function(error) {
      clearCachedTurnstileToken(state);
      state.tokenPromise = null;
      throw error;
    });

    return state.tokenPromise;
  }

  function prewarmTurnstile(root) {
    var siteKey = root.dataset.turnstileSitekey || "";
    var state = getTurnstileState(root);

    if (!siteKey || isTurnstileTokenFresh(state) || state.tokenPromise) {
      return;
    }

    getTurnstileToken(root).catch(function() {
      clearCachedTurnstileToken(state);
    });
  }

  function scheduleTurnstilePrewarm(root, emailInput) {
    var state = getTurnstileState(root);

    if (!root.dataset.turnstileSitekey || !emailInput || !looksLikeEmail(emailInput.value)) {
      return;
    }

    if (state.prewarmTimerId) {
      window.clearTimeout(state.prewarmTimerId);
    }

    state.prewarmTimerId = window.setTimeout(function() {
      state.prewarmTimerId = null;
      prewarmTurnstile(root);
    }, 300);
  }

  function setStatus(statusNode, state) {
    if (!statusNode) {
      return;
    }

    statusNode.textContent = state.message;
    statusNode.classList.remove("is-error", "is-success");

    if (state.type === "error") {
      statusNode.classList.add("is-error");
    } else if (state.type === "success") {
      statusNode.classList.add("is-success");
    }
  }

  function setView(root, view) {
    var states = root.querySelectorAll("[data-renewal-state]");

    states.forEach(function(state) {
      var matches = state.getAttribute("data-renewal-state") === view;
      state.hidden = !matches;
    });
  }

  function getPrimaryImage(item) {
    if (item.image) {
      return item.image;
    }

    if (item.variant && item.variant.image) {
      return item.variant.image;
    }

    if (item.variant && item.variant.media && item.variant.media.preview && item.variant.media.preview.image) {
      return item.variant.media.preview.image;
    }

    if (item.product && item.product.featuredImage) {
      return item.product.featuredImage;
    }

    if (item.product && item.product.featuredMedia && item.product.featuredMedia.preview && item.product.featuredMedia.preview.image) {
      return item.product.featuredMedia.preview.image;
    }

    return null;
  }

  function getItemUrl(item) {
    if (item.productUrl) {
      return item.productUrl;
    }

    if (item.url) {
      return item.url;
    }

    if (item.product && item.product.handle) {
      return "/products/" + item.product.handle;
    }

    return "";
  }

  function getRootItems(root) {
    return Array.isArray(root._renewalItems) ? root._renewalItems : [];
  }

  function getReorderableItems(root) {
    return getRootItems(root).filter(function(item) {
      return item.reorderable !== false && toNumericVariantId(item.variantId || (item.variant && item.variant.id));
    });
  }

  function extractFirstName(name) {
    if (!name) {
      return "";
    }

    return String(name).trim().split(/\s+/)[0] || "";
  }

  function getImageMarkup(item, className) {
    var image = getPrimaryImage(item);
    var imageUrl = image && image.url ? escapeHtml(image.url) : "";
    var imageAlt = escapeHtml(image && image.altText ? image.altText : (item.title || item.name || "Replacement item"));

    if (imageUrl) {
      return '<img class="' + className + '" src="' + imageUrl + '" alt="' + imageAlt + '" loading="lazy">';
    }

    return '<div class="ff-reorder-image__placeholder">Filter</div>';
  }

  function getOrderMetaMarkup(order) {
    var parts = [];

    if (order && order.createdAt) {
      parts.push("<span>Ordered <b>" + escapeHtml(formatOrderDate(order.createdAt)) + "</b></span>");
    }

    if (order && order.name) {
      parts.push("<span>Order <b>" + escapeHtml(order.name) + "</b></span>");
    }

    return parts.map(function(part, index) {
      return index === 0 ? part : '<span class="ff-reorder-order-card__dot" aria-hidden="true"></span>' + part;
    }).join("");
  }

  function getItemReference(item) {
    var quantity = Number(item.quantity || 1);
    var sku = item.sku || "";

    if (sku) {
      return quantity + " x " + sku;
    }

    return quantity + " x item";
  }

  function buildQuantityControl(item, index, size) {
    var reorderable = item.reorderable !== false;
    var value = Number(item.selectedQuantity || item.quantity || 1);
    var isPrimary = size === "primary";

    return [
      '<div class="ff-reorder-quantity' + (isPrimary ? "" : " ff-reorder-quantity--compact") + '" role="group" aria-label="Quantity">',
      '  <span class="ff-reorder-quantity__label">Quantity</span>',
      '  <div class="ff-reorder-quantity__control">',
      '    <button type="button" class="ff-reorder-quantity__button" data-qty-step="-1" data-item-index="' + index + '"' + (reorderable ? "" : " disabled") + ' aria-label="Decrease quantity">',
      '      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path></svg>',
      "    </button>",
      '    <span class="ff-reorder-quantity__value" data-qty-value="' + index + '">' + value + "</span>",
      '    <button type="button" class="ff-reorder-quantity__button" data-qty-step="1" data-item-index="' + index + '"' + (reorderable ? "" : " disabled") + ' aria-label="Increase quantity">',
      '      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14"></path><path d="M5 12h14"></path></svg>',
      "    </button>",
      "  </div>",
      "</div>"
    ].join("");
  }

  function buildPrimaryCardMarkup(item, order, index) {
    var itemUrl = escapeHtml(getItemUrl(item));
    var title = escapeHtml(item.title || item.name || "Replacement item");
    var itemTotal = item.totalPrice && item.totalPrice.amount
      ? formatMoney(item.totalPrice.amount, item.totalPrice.currencyCode)
      : "";
    var summaryNote = item.reorderable !== false
      ? "Current live product ready to add back to basket."
      : escapeHtml(item.note || "This item is not currently available to add automatically.");
    var buttonLabel = item.reorderable !== false ? "Add to basket" : "Unavailable";
    var buttonClass = item.reorderable !== false ? "ff-reorder-button--primary" : "ff-reorder-button--disabled";
    var mediaMarkup = getImageMarkup(item, "ff-reorder-order-card__image");
    var itemReference = escapeHtml(getItemReference(item));

    return [
      '<article class="ff-reorder-order-card">',
      '  <div class="ff-reorder-order-card__image-wrap">' + mediaMarkup + "</div>",
      '  <div class="ff-reorder-order-card__info">',
      '    <div class="ff-reorder-order-card__meta">' + getOrderMetaMarkup(order) + "</div>",
      '    <span class="ff-reorder-order-card__eyebrow">' + itemReference + "</span>",
      itemUrl
        ? '    <h3 class="ff-reorder-order-card__title"><a href="' + itemUrl + '">' + title + "</a></h3>"
        : '    <h3 class="ff-reorder-order-card__title">' + title + "</h3>",
      itemTotal
        ? '    <div class="ff-reorder-order-card__summary"><span class="ff-reorder-order-card__summary-value">Item total ' + escapeHtml(itemTotal) + '</span><span class="ff-reorder-order-card__summary-note">' + summaryNote + "</span></div>"
        : '    <div class="ff-reorder-order-card__summary"><span class="ff-reorder-order-card__summary-value">Original quantity ' + escapeHtml(item.quantity || 1) + '</span><span class="ff-reorder-order-card__summary-note">' + summaryNote + "</span></div>",
      item.note && item.reorderable === false ? '    <p class="ff-reorder-order-card__note">' + escapeHtml(item.note) + "</p>" : "",
      "  </div>",
      '  <div class="ff-reorder-order-card__actions">',
      buildQuantityControl(item, index, "primary"),
      '    <button type="button" class="ff-reorder-button ' + buttonClass + '" data-add-item data-item-index="' + index + '" data-default-label="' + escapeHtml(buttonLabel) + '"' + (item.reorderable !== false ? "" : " disabled") + ">" + buttonLabel + "</button>",
      itemUrl ? '    <a class="ff-reorder-button ff-reorder-button--tertiary" href="' + itemUrl + '">View product</a>' : "",
      "  </div>",
      "</article>"
    ].filter(Boolean).join("");
  }

  function buildSecondaryCardMarkup(item, order, index) {
    var itemUrl = escapeHtml(getItemUrl(item));
    var title = escapeHtml(item.title || item.name || "Replacement item");
    var sku = escapeHtml(item.sku || "");
    var note = item.reorderable !== false
      ? "Ready to add"
      : escapeHtml(item.note || "Unavailable");
    var buttonLabel = item.reorderable !== false ? "Add" : "Unavailable";
    var buttonClass = item.reorderable !== false ? "ff-reorder-button--secondary" : "ff-reorder-button--disabled";

    return [
      '<article class="ff-reorder-secondary-card">',
      '  <div class="ff-reorder-secondary-card__media">' + getImageMarkup(item, "ff-reorder-secondary-card__image") + "</div>",
      '  <div class="ff-reorder-secondary-card__body">',
      itemUrl
        ? '    <h4 class="ff-reorder-secondary-card__title"><a href="' + itemUrl + '">' + title + "</a></h4>"
        : '    <h4 class="ff-reorder-secondary-card__title">' + title + "</h4>",
      '    <p class="ff-reorder-secondary-card__meta">' + getOrderMetaMarkup(order) + "</p>",
      '    <p class="ff-reorder-secondary-card__sku">' + escapeHtml(getItemReference(item)) + "</p>",
      '    <p class="ff-reorder-secondary-card__note">' + note + "</p>",
      "  </div>",
      '  <div class="ff-reorder-secondary-card__actions">',
      buildQuantityControl(item, index, "secondary"),
      '    <button type="button" class="ff-reorder-button ' + buttonClass + '" data-add-item data-item-index="' + index + '" data-default-label="' + escapeHtml(buttonLabel) + '"' + (item.reorderable !== false ? "" : " disabled") + ">" + buttonLabel + "</button>",
      "  </div>",
      "</article>"
    ].filter(Boolean).join("");
  }

  function updateReorderAllButton(root) {
    var reorderAllButton = root.querySelector("[data-reorder-all]");
    var reorderableItems = getReorderableItems(root);

    if (!reorderAllButton) {
      return;
    }

    reorderAllButton.hidden = reorderableItems.length < 2;
  }

  function renderResults(root, payload) {
    var welcomeHeading = root.querySelector("[data-renewal-welcome-heading]");
    var welcomeCopy = root.querySelector("[data-renewal-welcome-copy]");
    var primary = root.querySelector("[data-renewal-primary]");
    var secondary = root.querySelector("[data-renewal-secondary]");
    var secondaryList = root.querySelector("[data-renewal-secondary-list]");
    var addressStrip = root.querySelector("[data-renewal-address]");
    var addressSummary = root.querySelector("[data-renewal-address-summary]");
    var cartStatus = root.querySelector("[data-renewal-cart-status]");
    var order = payload.order || {};
    var items = Array.isArray(payload.items) ? payload.items : [];
    var primaryIndex;
    var customerName = order.shippingAddress && order.shippingAddress.name ? extractFirstName(order.shippingAddress.name) : "";
    var addressText = order.shippingAddress && order.shippingAddress.summary ? order.shippingAddress.summary : "";

    root._renewalItems = items.map(function(item) {
      return Object.assign({}, item, {
        selectedQuantity: Number(item.quantity || 1)
      });
    });

    if (!items.length) {
      setStatus(cartStatus, createStatus("We found a matching order, but there are no items available to show for re-order.", "error"));
      return;
    }

    primaryIndex = root._renewalItems.findIndex(function(item) {
      return item.reorderable !== false;
    });

    if (primaryIndex < 0) {
      primaryIndex = 0;
    }

    setStatus(cartStatus, createStatus("", ""));

    if (welcomeHeading) {
      welcomeHeading.textContent = customerName ? "Welcome back, " + customerName + "." : "We found your latest order.";
    }

    if (welcomeCopy) {
      welcomeCopy.textContent = order.createdAt
        ? "Your last order was placed on " + formatOrderDate(order.createdAt) + ". Review the items below and add the ones you want back to basket."
        : "Review the items below and add the ones you want back to basket.";
    }

    if (primary) {
      primary.innerHTML = buildPrimaryCardMarkup(root._renewalItems[primaryIndex], order, primaryIndex);
    }

    if (secondary && secondaryList) {
      var additionalItems = root._renewalItems.reduce(function(list, item, index) {
        if (index !== primaryIndex) {
          list.push({
            item: item,
            index: index
          });
        }

        return list;
      }, []);

      if (additionalItems.length) {
        secondary.hidden = false;
        secondaryList.innerHTML = additionalItems.map(function(entry) {
          return buildSecondaryCardMarkup(entry.item, order, entry.index);
        }).join("");
      } else {
        secondary.hidden = true;
        secondaryList.innerHTML = "";
      }
    }

    if (addressStrip && addressSummary) {
      if (addressText) {
        addressStrip.hidden = false;
        addressSummary.textContent = addressText;
      } else {
        addressStrip.hidden = true;
        addressSummary.textContent = "";
      }
    }

    updateReorderAllButton(root);
    setView(root, "results");
  }

  function resetResults(root) {
    var primary = root.querySelector("[data-renewal-primary]");
    var secondary = root.querySelector("[data-renewal-secondary]");
    var secondaryList = root.querySelector("[data-renewal-secondary-list]");
    var addressStrip = root.querySelector("[data-renewal-address]");
    var addressSummary = root.querySelector("[data-renewal-address-summary]");
    var cartStatus = root.querySelector("[data-renewal-cart-status]");
    var reorderAllButton = root.querySelector("[data-reorder-all]");

    root._renewalItems = [];

    if (primary) {
      primary.innerHTML = "";
    }

    if (secondary) {
      secondary.hidden = true;
    }

    if (secondaryList) {
      secondaryList.innerHTML = "";
    }

    if (addressStrip) {
      addressStrip.hidden = true;
    }

    if (addressSummary) {
      addressSummary.textContent = "";
    }

    if (reorderAllButton) {
      reorderAllButton.hidden = true;
    }

    setStatus(cartStatus, createStatus("", ""));
    setView(root, "lookup");
  }

  function updateQuantity(root, itemIndex, delta) {
    var items = getRootItems(root);
    var item = items[itemIndex];
    var valueNodes;

    if (!item) {
      return;
    }

    item.selectedQuantity = Math.max(1, Math.min(10, Number(item.selectedQuantity || item.quantity || 1) + delta));

    valueNodes = root.querySelectorAll('[data-qty-value="' + itemIndex + '"]');
    valueNodes.forEach(function(node) {
      node.textContent = item.selectedQuantity;
    });
  }

  async function addItemsToCart(items, cartUrl) {
    var response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ items: items })
    });

    if (!response.ok) {
      var errorPayload = await response.json().catch(function() {
        return {};
      });
      throw new Error(errorPayload.description || errorPayload.message || "Unable to add the selected item to your basket.");
    }

    window.location.href = cartUrl || "/cart";
  }

  async function fetchWithTimeout(url, options, timeoutMs) {
    var controller;
    var timeoutId;

    if (!window.AbortController) {
      return fetch(url, options);
    }

    controller = new AbortController();
    timeoutId = window.setTimeout(function() {
      controller.abort();
    }, timeoutMs || 20000);

    try {
      return await fetch(url, Object.assign({}, options, {
        signal: controller.signal
      }));
    } catch (error) {
      if (error && error.name === "AbortError") {
        throw new Error("The order lookup took too long. Please try again.");
      }

      throw error;
    } finally {
      window.clearTimeout(timeoutId);
    }
  }

  function getCartPayloadForItem(root, itemIndex) {
    var items = getRootItems(root);
    var item = items[itemIndex];
    var variantId;

    if (!item) {
      return null;
    }

    variantId = toNumericVariantId(item.variantId || (item.variant && item.variant.id));

    if (!variantId || item.reorderable === false) {
      return null;
    }

    return {
      id: variantId,
      quantity: Number(item.selectedQuantity || item.quantity || 1)
    };
  }

  function initRenewalPage(root) {
    var form = root.querySelector("[data-renewal-form]");
    var submitButton = root.querySelector("[data-renewal-submit]");
    var statusNode = root.querySelector("[data-renewal-status]");
    var cartStatusNode = root.querySelector("[data-renewal-cart-status]");
    var emailInput;
    var postcodeInput;
    var endpoint = root.dataset.lookupEndpoint || "";
    var cartUrl = root.dataset.cartUrl || "/cart";
    var siteKey = root.dataset.turnstileSitekey || "";

    if (!form || !submitButton) {
      return;
    }

    root._renewalItems = [];
    setView(root, "lookup");
    emailInput = form.querySelector('input[name="email"]');
    postcodeInput = form.querySelector('input[name="postcode"]');

    if (renewalRoots.indexOf(root) === -1) {
      renewalRoots.push(root);
    }

    if (siteKey) {
      ensureTurnstileScript();
      renderTurnstileWidget(root);
    }

    if (postcodeInput) {
      postcodeInput.addEventListener("input", function() {
        var formatted = formatPostcodeInput(postcodeInput.value);

        if (postcodeInput.value !== formatted) {
          postcodeInput.value = formatted;
        }

        scheduleTurnstilePrewarm(root, emailInput);
      });

      postcodeInput.addEventListener("focus", function() {
        scheduleTurnstilePrewarm(root, emailInput);
      });
    }

    if (emailInput) {
      emailInput.addEventListener("input", function() {
        scheduleTurnstilePrewarm(root, emailInput);
      });

      emailInput.addEventListener("blur", function() {
        scheduleTurnstilePrewarm(root, emailInput);
      });
    }

    form.addEventListener("submit", async function(event) {
      var token = "";
      event.preventDefault();
      resetResults(root);
      setStatus(statusNode, createStatus("", ""));

      var formData = new FormData(form);
      var rawPostcode = postcodeInput ? postcodeInput.value : (formData.get("postcode") || "").toString();
      var postcode = formatPostcodeInput(rawPostcode);
      var email = (formData.get("email") || "").toString().trim();

      if (!postcode || !email) {
        setStatus(statusNode, createStatus("Enter the postcode and email used on your last order.", "error"));
        return;
      }

      if (!looksLikeEmail(email)) {
        setStatus(statusNode, createStatus("Enter a valid email address.", "error"));
        return;
      }

      if (postcodeInput) {
        postcodeInput.value = postcode;
      }

      if (!endpoint) {
        setStatus(statusNode, createStatus("The renewal lookup endpoint has not been connected yet.", "error"));
        return;
      }

      submitButton.disabled = true;
      setButtonLabel(submitButton, "Checking order...");
      setStatus(statusNode, createStatus("Checking your previous order...", ""));

      try {
        if (siteKey) {
          token = await getTurnstileToken(root);
        }

        var response = await fetchWithTimeout(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            email: email,
            postcode: postcode,
            token: token
          })
        }, 20000);

        var payload = await response.json().catch(function() {
          return {};
        });

        if (!response.ok || payload.found === false || !payload.order) {
          setStatus(
            statusNode,
            createStatus(payload.message || payload.error || "We could not find a matching order with those details.", "error")
          );
          return;
        }

        renderResults(root, payload);
      } catch (error) {
        setStatus(
          statusNode,
          createStatus(error && error.message ? error.message : "Something went wrong while checking your order.", "error")
        );
      } finally {
        resetTurnstile(root);
        submitButton.disabled = false;
        setButtonLabel(submitButton, getButtonDefaultLabel(submitButton, root.dataset.submitLabel || "Find my order"));
      }
    });

    root.addEventListener("click", async function(event) {
      var resetButton = event.target.closest("[data-renewal-reset]");
      var stepButton = event.target.closest("[data-qty-step]");
      var itemButton = event.target.closest("[data-add-item]");
      var reorderAllButton = event.target.closest("[data-reorder-all]");

      if (resetButton) {
        event.preventDefault();
        setStatus(statusNode, createStatus("", ""));
        setStatus(cartStatusNode, createStatus("", ""));
        resetResults(root);
        return;
      }

      if (stepButton) {
        event.preventDefault();
        updateQuantity(root, Number(stepButton.dataset.itemIndex), Number(stepButton.dataset.qtyStep || 0));
        return;
      }

      if (itemButton) {
        event.preventDefault();

        try {
          var singleItem = getCartPayloadForItem(root, Number(itemButton.dataset.itemIndex));

          if (!singleItem) {
            throw new Error("This item is not currently available to add automatically.");
          }

          itemButton.disabled = true;
          setButtonLabel(itemButton, "Adding...");
          await addItemsToCart([singleItem], cartUrl);
        } catch (error) {
          itemButton.disabled = false;
          setButtonLabel(itemButton, getButtonDefaultLabel(itemButton, "Add"));
          setStatus(
            cartStatusNode,
            createStatus(error && error.message ? error.message : "Unable to add that item right now.", "error")
          );
        }

        return;
      }

      if (reorderAllButton) {
        event.preventDefault();

        try {
          var allItems = getReorderableItems(root).map(function(item) {
            return {
              id: toNumericVariantId(item.variantId || (item.variant && item.variant.id)),
              quantity: Number(item.selectedQuantity || item.quantity || 1)
            };
          });

          if (!allItems.length) {
            throw new Error("There are no items in this order that can be added automatically.");
          }

          reorderAllButton.disabled = true;
          setButtonLabel(reorderAllButton, "Adding items...");
          await addItemsToCart(allItems, cartUrl);
        } catch (error) {
          reorderAllButton.disabled = false;
          setButtonLabel(reorderAllButton, getButtonDefaultLabel(reorderAllButton, "Re-order all"));
          setStatus(
            cartStatusNode,
            createStatus(error && error.message ? error.message : "Unable to add those items right now.", "error")
          );
        }
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    var roots = document.querySelectorAll("[data-filter-renewal-root]");
    roots.forEach(initRenewalPage);
  });
})();
